import { observer } from 'mobx-react';
import { Link } from '../../../../../../../Resource/Types';
import { useOpenable } from '../../../../../../Modal/UseOpenable';
import LearningCollectionEditStore from '../../../../Edit/Store';
import { Section } from '../../../../Types';
import ConfirmationModal from './ConfirmationModal';
import OpenButton from './OpenButton';

interface Props {
  store: LearningCollectionEditStore;
  section: Section;
  link: Link;
}

function Display({ store, section, link }: Props) {
  const { open, close, modalState } = useOpenable();

  switch (modalState.kind) {
    case 'closed':
      return <OpenButton open={open} />;
    case 'open':
      return (
        <>
          <OpenButton open={open} />
          <ConfirmationModal store={store} section={section} link={link} close={close} />
        </>
      );
  }
}

export default observer(Display);
